export const getLocationOrigin = () => {
    return window.location.origin.toString();
}